/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Select_MonthInputs */

const fr_calendar_select_month = /** @type {(inputs: Calendar_Select_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir le mois`)
};

const en_calendar_select_month = /** @type {(inputs: Calendar_Select_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose month`)
};

/**
* | output |
* | --- |
* | "Choose month" |
*
* @param {Calendar_Select_MonthInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_select_month = /** @type {((inputs?: Calendar_Select_MonthInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Select_MonthInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_select_month(inputs)
	return fr_calendar_select_month(inputs)
});